import React from "react";
import Navbar from "./components/navbar";
import CreateMiCeluComponent from "./create/create.component";
import CreateMiCeluProvider from "./create/provider/createMiCelu.provider";
import CreateUsedMiCeluProvider from "./create/used/provider/createUsedMiCelu.provider";
import CreateNewsMiCeluProvider from "./create/news/provider/createNewsMiCelu.provider";
import LogoAcinco from "../../assets/images/logo_acinco_white.png";

const VirginPage = () => {
  return (
    <CreateMiCeluProvider>
      <CreateNewsMiCeluProvider>
        <CreateUsedMiCeluProvider>
          <div className="flex h-screen flex-col overflow-auto bg-gradient-to-b from-white to-[#E32B24]">
            <Navbar />
            <section className="z-10 flex h-full w-full items-center justify-center p-0">
              <div className="container mb-auto mt-auto w-full px-4 lg:px-20">
                <CreateMiCeluComponent />
              </div>
            </section>
            <div className="absolute bottom-0 mb-4 flex w-full items-center justify-center text-white">
              Respaldado por{"   "}
              <img
                src={LogoAcinco}
                alt="logo_acinco"
                className="ml-2 max-h-14"
              />
            </div>
          </div>
        </CreateUsedMiCeluProvider>
      </CreateNewsMiCeluProvider>
    </CreateMiCeluProvider>
  );
};

export default VirginPage;
